import { useCallback, useState } from "react";
import { useAppContext } from "../../providers/ProviderAppContainer";
import { Dialog } from "primereact/dialog";
import TabHeader from "../common/TabHeader";
import { FloatLabel } from "primereact/floatlabel";
import { InputText } from "primereact/inputtext";
import { Button } from "primereact/button";
import CheckboxInput from "../common/CheckBoxInput";
import HasRequiredAuthority from "../dependencies/HasRequiredAuthority";
import { AUTHORITIES } from "../../constants";

export default function DialogEditCouponCode({ visible, setCouponCodes, closeDialog, ...props }) {
    const { requestAPI, showToast } = useAppContext();

    const [couponCode, setCouponCode] = useState(props);
    const [loading, setLoading] = useState();

    const editCouponCode = useCallback(() => {
        requestAPI({
            requestPath: `coupon-codes`,
            requestMethod: "PATCH",
            requestPostBody: couponCode,
            setLoading: setLoading,
            onRequestFailure: () => showToast({ severity: "error", summary: "Failed", detail: "Failed To Add Coupon Code !", life: 2000 }),
            onResponseReceieved: (updatedCourse, responseCode) => {
                if (updatedCourse && responseCode === 200) {
                    showToast({ severity: "success", summary: "Updated", detail: "Course Updated", life: 1000 });
                    setCouponCodes((prev) => prev?.map((course) => (course?.id === props?.id ? updatedCourse : course)));
                    setCouponCode(); //reset form
                    closeDialog(); //close the dialog
                } else showToast({ severity: "error", summary: "Failed", detail: "Failed To Update Course !", life: 2000 });
            },
        });
    }, [closeDialog, couponCode, props, requestAPI, setCouponCodes, showToast]);

    return (
        <Dialog pt={{ content: { className: "overflow-visible" } }} header={`Edit Coupon Code`} visible={visible} className="w-11" onHide={closeDialog}>
            <TabHeader className="pt-3" title="Edit Coupon Code" />

            <FloatLabel className="mt-5">
                <InputText
                    value={couponCode?.code || ""}
                    id="code"
                    className="w-full"
                    onChange={(e) => setCouponCode((prev) => ({ ...prev, code: e.target.value }))}
                    disabled={loading}
                />
                <label htmlFor="code">Code</label>
            </FloatLabel>

            <CheckboxInput
                className={"mt-3"}
                label={"Active"}
                checked={!!couponCode?.active}
                onChange={(checked) => setCouponCode((prev) => ({ ...prev, active: checked }))}
            />

            <HasRequiredAuthority requiredAuthority={AUTHORITIES.UPDATE_COUPON_CODE}>
                <Button className="mt-3" label="Edit Coupon Code" severity="warning" loading={loading} onClick={editCouponCode} />
            </HasRequiredAuthority>
        </Dialog>
    );
}
